import React, { PropTypes } from 'react';
import Collapsible from 'react-collapsible';
import { Link } from 'react-router';

import Container from '../../../Container';
import TicketList from '../TicketList';

import { heading1 } from '../../styles.module.css';
import {
  arrow,
  back,
  button,
  container,
  trigger,
  triggerHidden,
  triggerOpen,
  unavailableList,
} from './styles.module.css';

/**
 * Event tickets presentational component.
 */
const EventTickets = ({
  eventPermalink,
  racesWithAvailableTickets,
  racesWithoutAvailableTickets,
}) => (
  <Container className={container}>
    {racesWithAvailableTickets.length > 0 && (
      <div>
        <h1 className={heading1}>{'Choose your ticket'}</h1>
        <TicketList races={racesWithAvailableTickets} />
      </div>
    )}
    {racesWithAvailableTickets.length === 0 && (
      <h1 className={heading1}>{'No tickets available'}</h1>
    )}
    {racesWithoutAvailableTickets.length > 0 && (
      <Collapsible
        open={racesWithAvailableTickets.length === 0}
        transitionTime={100}
        transitionCloseTime={100}
        triggerClassName={racesWithAvailableTickets.length === 0 ? triggerHidden : trigger}
        triggerOpenedClassName={
          racesWithAvailableTickets.length === 0 ? triggerHidden : triggerOpen
        }
        trigger={<button className={button}>{'View unavailable tickets'}</button>}
      >
        <div className={racesWithAvailableTickets.length > 0 && unavailableList}>
          <TicketList races={racesWithoutAvailableTickets} />
        </div>
      </Collapsible>
    )}
    <Link to={eventPermalink} className={back}>
      <span className={arrow} />
      {'Back to event'}
    </Link>
  </Container>
);

EventTickets.propTypes = {
  eventPermalink: PropTypes.string.isRequired,
  racesWithAvailableTickets: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  racesWithoutAvailableTickets: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default EventTickets;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/EventTickets/component.jsx